import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { useAuth } from "./AuthContext";
import { toast } from "sonner";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [open, setOpen] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setItems([]); setWishlist([]); return; }
    try {
      const [c, w] = await Promise.all([api.get("/cart"), api.get("/wishlist")]);
      setItems(c.data); setWishlist(w.data);
    } catch (e) { /* noop */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (product_id, quantity = 1) => {
    if (!user) { toast.error("Autentifică-te pentru a adăuga în coș"); return; }
    await api.post("/cart/add", { product_id, quantity });
    await refresh();
    setOpen(true);
    toast.success("Adăugat în coș");
  };

  const remove = async (product_id) => {
    await api.delete(`/cart/${product_id}`);
    await refresh();
  };

  const toggleWishlist = async (product_id) => {
    if (!user) { toast.error("Autentifică-te pentru lista de dorințe"); return; }
    await api.post(`/wishlist/toggle/${product_id}`);
    await refresh();
  };

  const isWishlisted = (id) => wishlist.some(p => p.id === id);

  const total = items.reduce((s, it) => s + it.product.price * it.quantity, 0);
  const count = items.reduce((s, it) => s + it.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, wishlist, open, setOpen, add, remove, toggleWishlist, isWishlisted, refresh, total, count }}>
      {children}
    </CartCtx.Provider>
  );
}
